import React from "react";
import Accordions from "../../../components/Accordions";

const Sem2MECH1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/1hDyTZzDOhgU3c0hvxcgZFS03OApuRs_k/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1fpTjnZIL4Oet6nTYeKTW_mfvi5EuUOIQ/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">MECH Sem - 2</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem2MECH1;
